interface ArrowIconProps extends React.SVGProps<SVGSVGElement> {
	direction: "left" | "right";
}

const ArrowIcon = ({ direction, ...props }: ArrowIconProps) => {
	return (
		<svg
			style={{
				transform:
					direction === "right" ? "rotate(180deg)" : "rotate(0deg)",
			}}
			width={"24"}
			height={"17"}
			viewBox="0 0 24 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M5.77559 10L10.0506 14.275C10.3506 14.575 10.4943 14.925 10.4818 15.325C10.4693 15.725 10.3256 16.075 10.0506 16.375C9.75059 16.675 9.39434 16.8313 8.98184 16.8438C8.56934 16.8563 8.21309 16.7125 7.91309 16.4125L1.05059 9.55002C0.750586 9.25002 0.600586 8.90002 0.600586 8.50002C0.600586 8.10002 0.750586 7.75002 1.05059 7.45002L7.91309 0.587518C8.21309 0.287518 8.56934 0.143768 8.98184 0.156268C9.39434 0.168768 9.75059 0.325018 10.0506 0.625018C10.3256 0.925018 10.4693 1.27502 10.4818 1.67502C10.4943 2.07502 10.3506 2.42502 10.0506 2.72502L5.77559 7.00002H22.5006C22.9256 7.00002 23.2818 7.14377 23.5693 7.43127C23.8568 7.71877 24.0006 8.07502 24.0006 8.50002C24.0006 8.92502 23.8568 9.28127 23.5693 9.56877C23.2818 9.85627 22.9256 10 22.5006 10H5.77559Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default ArrowIcon;
